import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import utils from '.';
import store from '../state/store';
import AsyncStorage from './safeAsyncStorageProvider';
export var getAffId = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(utils.getPlatform() === 'web')) {
              _context.next = 4;
              break;
            }

            _context.t0 = store.getState().playerInfo.aff_id;
            _context.next = 7;
            break;

          case 4:
            _context.next = 6;
            return AsyncStorage.getItem('aff_id');

          case 6:
            _context.t0 = _context.sent;

          case 7:
            return _context.abrupt("return", _context.t0);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getAffId() {
    return _ref.apply(this, arguments);
  };
}();